<template>
  <v-menu
    data-testId="menu-CSV-export"
    offset-y>
    <template v-slot:activator="{ on }">
      <v-btn
        :disabled="!isValidationOk || loading || disable"
        data-testId="btn-CSV-export"
        color="dover-blue"
        dark
        small
        v-on="on">
        {{ $t('CSV export') }}
      </v-btn>
    </template>
    <v-list data-testId="list">
      <v-list-tile
        v-for="(item, index) in separators"
        :key="index"
        data-testId="list-tile"
        content-class="dover-blue"
        @click="csvExport(item.code)">
        <v-list-tile-title data-testId="list-tile-title-item-desc">{{ item.desc }}</v-list-tile-title>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  props: {
    isValidationOk: {
      type: Boolean,
      required: true,
      default: () => []
    },
    disable: {
      type: Boolean,
      required: false,
      default: false
    },
    loading: {
      type: Boolean,
      required: true,
      default: () => []
    }
  },
  data: () => ({
    separators: []
  }),
  mounted () {
    this.separators = [
      { code: ',', desc: this.$t('Comma sep') },
      { code: ';', desc: this.$t('Semicolon sep') },
      { code: '\t', desc: this.$t('Tab sep') }
    ]
  },
  methods: {
    csvExport (sep) {
      this.$emit('csvExport', sep)
    }
  }
}
</script>
